import { useEffect } from 'react';
import { withWindow } from '@shared/utils/withWindow';

let lockCount = 0;
let originalOverflow = '';

/**
 * Locks body scroll when `isLocked` is true, restoring the original overflow value
 * when all consumers have unlocked. Safe for concurrent use by multiple components.
 */
export const useBodyScrollLock = (isLocked: boolean): void => {
  useEffect(() => {
    if (!isLocked) return;

    return withWindow(
      global => {
        if (lockCount === 0) {
          originalOverflow = global.document.body.style.overflow || '';
        }
        lockCount++;
        global.document.body.style.overflow = 'hidden';

        return () => {
          lockCount--;
          if (lockCount === 0) {
            global.document.body.style.overflow = originalOverflow;
          }
        };
      },
      () => {},
    );
  }, [isLocked]);
};
